import { render } from "./SelectCard.vue?vue&type=template&id=6d5a4d63"
import script from "./SelectCard.vue?vue&type=script&lang=js"
export * from "./SelectCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__